
import React from 'react';
import * as microsoftTeams from '@microsoft/teams-js'
import ReactDOM from "react-dom";
import App from "../App";
import loader from '../Images/loader.gif'

let accessToken: string;
let idToken: string;
let userData: any;


export const getIdToken = () => idToken
export const getAccessToken = () => accessToken;
export const getUserData = () => userData;


export const autenticate = () => {
    getAccess()
    return <img className='loader' alt="Loader" src={loader}></img>
}

const getAccess = async () => {
    microsoftTeams.initialize()
  
    await getClientSideToken()
        .then((clientSideToken: any) => {
            ReactDOM.render(<App />, document.getElementById('root'));
        })
        .catch((error) => {
            if (error.includes("invalid") ) {
                // Display in-line button so user can consent
                ReactDOM.render(<button id="login" onClick={homeLogin}>Sign In</button>, document.getElementById('root'));
            } else {
                // Something else went wrong
            }
        });
    // })
}

const getClientSideToken = () => {
    return new Promise((resolve, reject) => {
        microsoftTeams.authentication.getAuthToken({
            successCallback: (result) => {
                idToken = result;
                resolve(result);
            },
            failureCallback: function (error) {
                reject("Error getting token: " + error);
            }
        });

    });

}

export const getUserInfo=():any=>{
    microsoftTeams.initialize();
       microsoftTeams.initialize(async () => {
        microsoftTeams.getContext((userInfo) => {
            userData = userInfo
            return userData;
        })
    })
}

export const homeLogin = async () => {
    return await getToken().then((data: any) => {
        accessToken = data.accessToken;
        idToken = data.idToken;
        ReactDOM.render(<App />, document.getElementById('root'));
    });
}

const getToken = () => {
    return new Promise((resolve, reject) => {
        microsoftTeams.initialize(async () => {
            await microsoftTeams.authentication.authenticate({
                url: window.location.origin + "/start.html",
                width: 600,
                height: 535,
                successCallback: result => {
                    resolve(result);
                },
                failureCallback: reason => {
                    reject(reason);
                }
            });
        })
    });
}